export interface CompanyOffice {
  readonly id: string;
  readonly name: string;
}

class Company {
  id?: string;

  name = '';

  contactName = '';

  contactEmail = '';

  contactPhoneNumber = '';

  contactAddress = '';

  contactCity = '';

  officeCount?: number;

  offices?: CompanyOffice[];
}

export default Company;
